<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>

              <div class="modal-header row" style="justify-content: flex-end;">
                <!-- <div class="col-6">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                </div> -->
                <div class="col">
                  <button type="button" class="close" @click="$emit('closeModal')">
                      <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="modal-body" v-if="dataReady">
                <h1>Detail</h1>

                <!-- <div class="row mt-5 mb-3">
                  
                  <div class="col-md-6 text-center">
                    <label class="font-weight-bold" for="partshopCode">Merk Mobil</label>
                    <h3>{{ data.car_brand_name }}</h3>
                  </div>
                  <div class="col-md-6 text-center" >
                    <label class="font-weight-bold" for="partshopCode">Tipe Mobil</label>
                    <h3>{{ data.car_name }}</h3>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4 text-center" >
                    <label class="font-weight-bold" for="partshopCode">Nama Pelanggan</label>
                    <h3>{{ data.name }}</h3>
                  </div>
                  <div class="col-md-4 text-center">
                    <label class="font-weight-bold" for="partshopCode">No Telfon Customer</label>
                    <h3>{{ data.phone_number }}</h3>
                  </div>
                  <div class="col-md-4 text-center">
                     <label class="font-weight-bold" for="partshopCode">Plat Nomor Mobil</label>
                    <h3 v-if="data.registration">{{ data.registration }}</h3>
                    <h3 v-else>-</h3>
                  </div>
                </div> -->
                <div class="row mb-2" style="font-size:16px">
                  <div class="col-md-6 col-12 mt-3">
                    <div class="row">
                      <div class="col-md-5">
                        Nomor Reference
                      </div>
                      <div class="col-md-1">
                        :
                      </div>
                      <div class="col-md-6">
                        {{detailId}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mt-3">
                    <div class="row">
                      <div class="col-md-5">
                        Plat Nomor Mobil
                      </div>
                      <div class="col-md-1">
                        :
                      </div>
                      <div class="col-md-6">
                        {{data.registration}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mt-3">
                    <div class="row">
                      <div class="col-md-5">
                        Nama Pelanggan
                      </div>
                      <div class="col-md-1">
                        :
                      </div>
                      <div class="col-md-6">
                        {{data.name}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mt-3">
                    <div class="row">
                      <div class="col-md-5">
                        Tipe Mobil
                      </div>
                      <div class="col-md-1">
                        :
                      </div>
                      <div class="col-md-6">
                        {{data.car_name}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mt-3">
                    <div class="row">
                      <div class="col-md-5">
                        Merek Mobil
                      </div>
                      <div class="col-md-1">
                        :
                      </div>
                      <div class="col-md-6">
                        {{data.car_brand_name}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mt-3">
                    <div class="row">
                      <div class="col-md-5">
                        Nomor Telepon
                      </div>
                      <div class="col-md-1">
                        :
                      </div>
                      <div class="col-md-6">
                        {{data.phone_number}}
                      </div>
                    </div>
                  </div>
                </div>
                

                <table class="table table-striped mt-3">
                  <thead style="background-color : #979797 !important;font-size:14px;padding:0.9em">
                    <tr>
                      <th>No</th>
                      <th>Sparepart</th>
                      <th>Deskripsi</th>
                      <th>Tipe</th>
                      <th>Jumlah</th>
                      <th>Harga Satuan</th>
                      <th>Harga Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(sparepart, index) in data.spareparts.filter(x => !x.deleted_at)" style="font-size:14px">
                      <td>{{ index+1 }}</td>
                      <td>{{ sparepart.sparepart_name ? sparepart.sparepart_name : '-' }}</td>
                      <td>{{ sparepart.part_number ? sparepart.part_number : '-' }}</td>
                      <td>{{ sparepart.sparepart_type == 1 ? 'J' : 'P'}}</td>
                      <td>{{ numberWithCommas(sparepart.quantity) }}</td>
                      <td v-if="sparepart.sparepart_type == 1">
                        Rp. {{ numberWithCommas(sparepart.supplier_prices ? sparepart.supplier_prices[0].price_per_item : 0) }}
                      </td>
                      <td v-else>
                        Rp. {{ numberWithCommas(sparepart.estimated_price ? sparepart.estimated_price : 0) }}
                      </td>
                      <td v-if="sparepart.sparepart_type == 1">
                        Rp. {{ numberWithCommas(sparepart.quantity * (sparepart.supplier_prices ? sparepart.supplier_prices[0].price_per_item : 0)) }}
                      </td>
                      <td v-else>
                        Rp. {{ numberWithCommas(sparepart.quantity * (sparepart.estimated_price ? sparepart.estimated_price : 0)) }}
                      </td>
                      <!-- <td>Rp. {{ numberWithCommas(sparepart.estimated_price ? sparepart.estimated_price : sparepart.supplier_prices ? sparepart.supplier_prices[0].price_per_item : '-') }}</td> -->
                      <!-- <td>Rp. {{ numberWithCommas(sparepart.quantity * (sparepart.estimated_price ? sparepart.estimated_price : sparepart.supplier_prices ? sparepart.supplier_prices[0].price_per_item : 0)) }}</td> -->
                    </tr>
                    <tr v-if="data.spareparts.length == 0">
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>X</td>
                    </tr>
                  </tbody>
                </table>
                

                <div class="row mt-2 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;">
                  <div class="col-md text-left">
                    <label style=" font-size: 16px;text-align: left !important;">Subtotal</label>
                  </div>
                  <div class="col-md text-right pr-4">
                    <label style=" font-size: 16px;text-align: right !important;">
                      Rp. {{numberWithCommas(this.data.ppn + overallTotal)}}.00
                    </label>
                  </div>
                </div>
                <hr>
                <div class="row mt-2 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;">
                  <div class="col-md text-left">
                    <label style=" font-size: 16px;text-align: left !important;">PPN</label>
                  </div>
                  <div class="col-md text-right pr-4">
                    <label style=" font-size: 16px;text-align: right !important;">
                      Rp. {{numberWithCommas(this.data.ppn)}}.00
                    </label>
                  </div>
                </div>

                <div class="row mt-5 mb-5">
                  <div class="col text-center">
                    <button type="button" class="btn btn-outline-danger" style="width: 200px;" @click="$emit('closeModal')">Kembali</button>
                    <button type="button" class="btn btn-primary ml-3" style="width: 200px;" @click="createProcessMobil">Buat Process Mobil</button>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
    </div>
  </div>
</transition>
</template>

<script>
  import moment from 'moment'
  export default {
    data () {
      return {
        options : this.$store.getters.getFilterOptions,
        mobile : this.isMobile(),
        dataReady : false,
        data : null,
      }
    },
    props : ['detailId'],
    mounted () {
      // console.log('hi');
      // this.options = this.$store.getters.getFilterOptions;
      this.getQuotationDetail();
    },
    computed : {
      overallTotal(){
        if(this.data != null){
          var total = 0;
          for(var i in this.data.spareparts){
            if(this.data.spareparts[i].deleted_at) continue;

            if(this.data.spareparts[i].sparepart_type == 1)
              total += (this.data.spareparts[i].supplier_prices ? this.data.spareparts[i].supplier_prices[0].price_per_item : 0)* this.data.spareparts[i].quantity
            else
              total += (this.data.spareparts[i].estimated_price ? parseInt(this.data.spareparts[i].estimated_price) : 0) * this.data.spareparts[i].quantity
          }
          return total;
        } else {
          return null;
        }
      }
    },
    methods : {
      createProcessMobil () {

        /*
          customer: {
						name: '',
						alias: '',
						phone_number: '',
						created_at: today,
						last_date: today,
						ktp : '',
						ktp_img : '',
						email : ''
						
					},
        */
        const ShortUniqueId = require('short-unique-id')
        const chassis = new ShortUniqueId({ length: 21 });
        const mesin = new ShortUniqueId({ length: 11 });

        let chassisTemp = 'TEMP' + chassis()
        let engin = 'TEMP' + mesin()
        
        let data = {
          form_code : this.detailId,
          serviceType : 'Process Mobil',
          registration : this.data.registration,
          CSO : this.$store.state.userData.userData.name,
          // customer : {
          //   name : this.data.name,
          //   alias : this.data.name,
          //   phone_number : this.data.phone_number
          // },
          customer_car : {
            chassis_number : chassisTemp,
            engine_number : engin,
            car_id : this.data.car_id,
            car_color_id : 1,
            last_km : 0,
            current_km : 0,
            registration : this.data.registration,
            year : '2000'

          },
          refChassis : chassisTemp,
          car_id : this.data.car_id,
          finishDate : moment().format('Y-MM-DD')
        }

        this.$http.post('/api/v1/workorder', {data : data})
        .then((resp) => {
          this.$store.dispatch('triggerAlert' , [true , 'Process Mobil Berhasil Dibuar.'])
          this.$router.push({ name : 'WorkOrderForm' });
        })
        .catch((err) => {
          this.$store.dispatch('triggerAlert' , [false , 'Something went wrong. Please Try Again or Contact Administrator'])
          console.log(err)
        })
      },
      getQuotationDetail(){
        this.$http.get(`/api/v1/quotation/${this.detailId}`)
        .then((resp)=>{
          this.data = resp.data.data;

          this.data.spareparts = this.data.spareparts.sort(function(a , b) {
            return b.sparepart_type - a.sparepart_type
          })
          this.calculatePPN()
        })
        .then(()=>{
          this.matchCar();
          // this.matchSparepart();
        })
        .then(()=>{
          this.dataReady = true;
        })
        .catch((err)=>{
          console.log(err);
        })
      },
      calculatePPN() {
        let ppn = 0

        for(var i = 0 ; i < this.data.spareparts.length ; i++) {
          if(this.data.spareparts[i].deleted_at) continue;
          let sparepart = this.data.spareparts[i]
          console.log(sparepart)

          if(!sparepart.supplier_prices || sparepart.supplier_prices.length == 0) continue;

          if(sparepart.supplier_prices[0].ppn_included || sparepart.supplier_prices[0].without_ppn)
            ppn += 0
          else {
            ppn += parseFloat(sparepart.supplier_prices[0].price_per_item) * 0.11
          }
        }

        this.data.ppn = ppn
      },
      matchCar(){
        //Search Car Brand
        // if (this.data.sparepart_brand_id <= this.options.brand.length && this.options.brand[this.data.sparepart_brand_id-1].id == this.data.sparepart_brand_id){
        //   this.data.car_brand_name = this.options.brand[this.data.sparepart_brand_id-1].name;
        // } else {
        //   this.data.car_brand_name = 'Unknown'
        //   for (var i = 0; i < this.options.brand.length; i++) {
        //     if (this.options.brand[i].id == this.data.sparepart_brand_id){
        //       this.data.car_brand_name = this.options.brand[i].name;
        //       i = this.options.brand.length+1
        //     }
        //   }
        // }

        //Search Car Type
        // if (this.data.car_id <= this.options.type.length && this.options.type[this.data.car_id-1].id == this.data.car_id){
        //   this.data.car_name = this.options.type[this.data.car_id-1].name;
        // } else {
        //   for (var i = 0; i < this.options.type.length; i++) {
        //     this.data.car_name = 'Unknown'
        //     if (this.options.type[i].id == this.data.car_id){
        //       this.data.car_name = this.options.type[i].name;
        //       i = this.options.type.length+1
        //     }
        //   }
        // }

        let car = this.$store.getters.getModelDetailById(this.data.car_id)
        this.data.car_brand_name = car.brand_name
        this.data.car_name = car.name
      },
      matchSparepart(){
        var spareparts = this.data.spareparts;

        //Search Sparepart Side Name
        // for(var i = 0; i < this.data.spareparts.length; i++){
        //   if (this.options.sparepartSide[spareparts[i].sparepart_side-1].id == spareparts[i].sparepart_side) {//Quick Position Guess
        //     this.data.spareparts[i].sparepart_side_name = this.options.sparepartSide[spareparts[i].sparepart_side-1].name;
        //   } else {//Guess Not Found
        //     for(var j = 0; j < this.options.sparepartSide.length; j++){
        //       if(spareparts[i].sparepart_side == this.options.sparepartSide[j].id){
        //         this.data.spareparts[i].sparepart_side_name = this.options.sparepartSide[j].name;
        //         j = this.options.sparepartSide.length+1;
        //       }
        //     }
        //   }
        // }

        //Search Sparepart Name
        for(var i = 0; i < this.data.spareparts.length; i++){
          // console.log('aaaaa');
          // console.log(JSON.stringify(this.options.sparepart[75].id));
          if (this.options.sparepart[spareparts[i].sparepart_id-1].id == spareparts[i].sparepart_id) {//Quick Position Guess
            this.data.spareparts[i].details = this.options.sparepart[spareparts[i].sparepart_id-1];
          } else {//Guess Not Found
            for(var j = 0; j < this.options.sparepart.length; j++){
              if(spareparts[i].sparepart_id == this.options.sparepart[j].id){
                this.data.spareparts[i].details = this.options.sparepart[j];
                j = this.options.sparepart.length+1;
              }
            }
          }
        }
      },
    }
  }
</script>

<style scoped>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


table thead tr th, table tbody tr td{
  text-align: center;
  vertical-align: middle;
}
</style>
